import { render, staticRenderFns } from "./SchedulingLaboratoryRecord.vue?vue&type=template&id=401a76d3&"
import script from "./SchedulingLaboratoryRecord.vue?vue&type=script&lang=js&"
export * from "./SchedulingLaboratoryRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports